import { cn } from "@/utils/cn"

export const SidebarContent = ({ className, ...props }: React.ComponentProps<"div">) => {
    return (
        <div
            data-slot="sidebar-content"
            data-sidebar="content"
            className={cn(
                "flex min-h-0 flex-1 flex-col overflow-auto group-data-[collapsible=icon]:overflow-hidden",
                className
            )}
            {...props}
        />
    )
}